/**
 * Campo por el que se ordena el listado de solicitudes cuando el usuario
 * selecciona un único tipo de certificado (ver RN-001/RN-003).
 * Corresponde al campo "Nº documento" (IRequestExpedient.certificateNumber).
 */
export const DOCUMENT_SORT_FIELD = "certificateNumber";
